import Icon from '../components/Icon';

const Weather3Colored = Icon(
  'weather-3-colored',
  <>
    <path
      fill="#57BDBE"
      d="M2.5 14.25a.75.75 0 0 0 0 1.5h16.75a1.5 1.5 0 1 1 0 3c-.68 0-1.346-.47-1.547-1.01a.75.75 0 1 0-1.406.52c.435 1.175 1.696 1.99 2.953 1.99a3 3 0 0 0 0-6z"
    />
    <path
      fill="#57BDBE"
      d="M2.5 17.25a.75.75 0 0 0 0 1.5h9a1.5 1.5 0 1 1 0 3c-.68 0-1.346-.47-1.547-1.01a.75.75 0 1 0-1.406.52c.435 1.175 1.696 1.99 2.953 1.99a3 3 0 0 0 0-6z"
    />
    <path
      fill="#D0D6CE"
      fillRule="evenodd"
      d="M3.307 5.849C3.633 3.118 5.98 1 8.824 1a5.56 5.56 0 0 1 4.8 2.729q.097-.005.197-.005C16.129 3.724 18 5.577 18 7.862S16.129 12 13.82 12H4.167C2.417 12 1 10.597 1 8.866a3.14 3.14 0 0 1 2.307-3.017"
      clipRule="evenodd"
    />
  </>
);

export default Weather3Colored;
